// Portal derin bağlantı çözümü (portal yetki v2 Dalga 3, TODO-KPI-57/9-10). Bildirim bağlantısı
// `/portal/kpi/tablo?setId=…&highlight=<gösterge kodu>&he=<işletme>&hy=<yıl>` çok firmalı kullanıcıda
// başka firmanın setini gösterebilir: set erişilebilirse aktif firma o firmaya geçer; erişilemiyorsa
// (ya da vurgu hedefi tabloda görünmüyorsa) HİÇBİR ŞEY açılmaz/vurgulanmaz — sızıntı yok, hata yok.
// Saf mantık; vitest ile kilitli (portal-deep-link.test.ts).

import type { KpiResolvedGrid } from "@mahir/shared";
import type { PortalSetSummary } from "../api/portal-kpi";

export interface DeepLinkHighlight {
  code: string;
  entityId: string | null;
  year: number | null;
}

export interface DeepLinkArgs {
  /** erişilebilir TÜM setler (firma süzgeci uygulanmamış) */
  sets: PortalSetSummary[];
  activeClientId: string | null;
  setId: string | null;
  highlight: string | null;
  he: string | null;
  hy: number | null;
  grid: KpiResolvedGrid | null;
  /**
   * Kullanıcının çalışabildiği firmalar (portal-store `firms`). Verilirse ve set başka bir firmanın ama o
   * firma listede YOKSA geçiş yapılamaz → bağlantı çözülmez (sayfa parametreleri temizler; takılı durum yok).
   */
  firmIds?: readonly string[] | null;
}

export interface DeepLinkTarget {
  /** doluysa aktif firma bu firmaya geçmeli (set başka firmanın ve erişilebilir) */
  switchClientId: string | null;
  /** tabloda gerçekten görünen hedef; aksi null */
  highlight: DeepLinkHighlight | null;
}

const NONE: DeepLinkTarget = { switchClientId: null, highlight: null };

export function deepLinkTarget(args: DeepLinkArgs): DeepLinkTarget {
  const { sets, activeClientId, setId, highlight, he, hy, grid, firmIds } = args;
  if (setId) {
    const set = sets.find((s) => s.id === setId);
    if (!set) return NONE; // erişimsiz/yok → hiçbir şey (varlık sızdırılmaz)
    if (activeClientId && set.clientId !== activeClientId) {
      if (firmIds && !firmIds.includes(set.clientId)) return NONE; // geçilemeyen firma
      return { switchClientId: set.clientId, highlight: null };
    }
  }
  if (!highlight || !grid) return NONE;
  if (setId && grid.setId !== setId) return NONE; // tablo henüz o setin değil
  const ind = grid.indicators.find((i) => i.code === highlight && i.structural !== true);
  if (!ind) return NONE;
  if (he !== null) {
    const leaf = grid.entities.find((e) => e.id === he && e.isActive);
    const isLeaf = !!leaf && !grid.entities.some((c) => c.parentId === he && c.isActive);
    if (!isLeaf) return NONE;
  }
  if (hy !== null && !grid.years.includes(hy)) return NONE;
  return { switchClientId: null, highlight: { code: ind.code, entityId: he, year: hy } };
}

const PROJECT_ROUTE = /^(?:\/portal)?\/projects\/([0-9a-f-]{36})(?:\/|$)/i;

/** Rota bir form projesine aitse üst bar firması o projenin firmasına bakmalı. */
export function routeFirmHint(pathname: string): { projectId: string } | null {
  const m = PROJECT_ROUTE.exec(pathname);
  return m?.[1] ? { projectId: m[1] } : null;
}
